import LinkProviderAccountDialog from './LinkProviderAccountDialog';

export default LinkProviderAccountDialog;
